const initialState = {
	list: [],
	page: 1,
	isListNext: false,
	datetime: null,
};

export default function reducer(state = initialState, action) {

	if (action.type === 'BESTPARTNER_LIST_SET') {
		let newState = Object.assign({}, state);
		newState.list = action.payload.list;
		newState.page = action.payload.page;
		newState.isListNext = action.payload.isListNext;
		newState.datetime = (new Date());
		return newState;
	}
	else if (action.type === 'BESTPARTNER_ITEM_SET') {
		let newState = Object.assign({}, state);
		let index = newState.list.findIndex((v) => v.mail_id === action.payload.mailId);
		if (index >= 0) {
			if (action.payload.type === 'read') {
				newState.list[index]['mail_unconfirmed_mail'] = 0;
			}
			if (action.payload.type === 'del') {
				newState.list.splice( index, 1 );
			}
		}
		return newState;
	}
	else {
		return state;
	}
}
